module.exports = __webpack_public_path__ + "static/media/media_radio.8f3d1db8.png";